<template>
    <div class="row">
      <div class="col-sm-12">
        <div v-if="!isMobile">
          <b-table hover responsive bordered
                   small
                   :items="accountHistory"
                   :fields="fields"
                   no-local-sorting>
            <template v-slot:cell(account_manager)="row">
              {{row.item.account_manager.name}}
            </template>
            <template v-slot:cell(affected_date)="row">
              <datepicker input-class="form-control"
                          style="position: unset;"
                          class="date"
                          :language="ru"
                          v-model="row.item.affected_date"
                          placeholder=""></datepicker>
            </template>
            <template v-slot:cell(actions)="row">
              <b-button size="sm" class="btn btn-primary"
                        style="color: #fff;background-color: #007dcc;border-color: #007dcc;"
                        @click.stop="saveHistory(row.item)">
                <i class="icon-fa icon-fa-save"></i>
              </b-button>
              <b-button size="sm" class="btn btn-danger"
                        @click.stop="deleteHistory(row)">
                <i class="icon-fa icon-fa-trash-o"></i>
              </b-button>
            </template>
          </b-table>
        </div>
        <div v-if="isMobile">
          <b-table hover responsive bordered stacked
                   small
                   :items="advertisers"
                   :fields="fields"
                   no-local-sorting>
            <template v-slot:cell(account_manager)="row">
              {{row.item.account_manager.name}}
            </template>
            <template v-slot:cell(affected_date)="row">
              <datepicker input-class="form-control"
                          style="position: unset;"
                          class="date"
                          :language="ru"
                          v-model="row.item.affected_date"
                          placeholder=""></datepicker>
            </template>
            <template v-slot:cell(actions)="row">
              <b-button size="sm" class="btn btn-primary"
                        style="color: #fff;background-color: #007dcc;border-color: #007dcc;"
                        @click.stop="saveHistory(row.item)">
                <i class="icon-fa icon-fa-save"></i>
              </b-button>
              <b-button size="sm" class="btn btn-danger"
                        @click.stop="deleteHistory(row)">
                <i class="icon-fa icon-fa-trash-o"></i>
              </b-button>
            </template>
          </b-table>
        </div>
      </div>
    </div>
</template>

<script>
import advertisersService from "../../../services/advertisersDataService";
import advertiserMixin from "../mixins/Advertiser/createUpdateMixin";
import Datepicker from 'vuejs-datepicker'
import {ru, th} from '../../../services/customLocaleDatepicker'

export default {
  name: "AccountHistoryModal",
  mixins: [advertiserMixin],
  props: {
    advertiser: Object
  },
    components: {
        Datepicker: Datepicker
    },
  data() {
    return {
        ru: ru,
        accountHistory: [],
        isMobile: false,
        fields: [
            {
                key: 'account_manager',
                label: 'АМ',
                sortable: false
            },
            {
                key: 'affected_date',
                label: 'Дата изменения Аккаунт Менеджера',
                sortable: false
            },
            {
                key: 'actions',
                label: 'Действия',
                tdAttr: {'align': "center"}
            }
        ]
    }
  },
  methods: {
      getAccountHistory() {
          advertisersService.getAccountHistory(this.advertiser.id)
              .then(function (response) {

                  this.accountHistory = response;
              }.bind(this))
      },
      saveHistory(item) {
          advertisersService.saveHistory(item.id, item.affected_date)
              .then(function (response) {
              })
      },
      deleteHistory(row) {
          advertisersService.deleteHistory(row.item.id)
              .then(function (response) {
                  if (response.status == true) {
                      this.accountHistory.splice(row.index, 1)
                  }
              }.bind(this))
      }
  },

  mounted() {
      this.getAccountHistory()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/views/front/modals/AccountHistoryModal.vue